export default __webpack_public_path__ + "static/media/IMG_5518 copie.7f67be03.jpg";